<template>
  <div>
    <Head title="Create Airport" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/airports">Airports</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Airport</li>
      </ol>
    </nav>
    <h1>Create Airport</h1>

    <div class="content-box">
      <form @submit.prevent="store">
        <AirportForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Airport</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import AirportForm from './components/AirportForm'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    AirportForm,
    LoadingButton
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        island_city: null,
        city: null,
        country: null,
        iata: null,
        icao: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/settings/airports')
    },
  },
}
</script>
